import axiosHandler from "./axiosHandler";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { setLQCOverallDescriptions, setShowReportTab } from "../Redux/actions";

export const fetchLeadEvaluationReports = async (
  user_super_oid: number,
  report_date: string,
  report_type: string,
  setReports: any,
  dispatcher: any
) => {
  try {
    let params: any = {
    user_super_oid,
    report_date,
    report_type,
    };
    const res = await axiosHandler.get(
      "reports/fetchLeadEvaluationReports",
      {
        params
      }
    );
    let lqcScoreDescriptions = {
      overallLeadQualification: "",
      overallLeadCalling: "",
      overallLeadQualificationValueMessage: "",
      overallLeadCallingValueMessage:""
    }
    res.data.data.forEach((report: any)=>{
      if(report.report_header === "Lead Qualification Score" && report.report_display === "Y"){
        lqcScoreDescriptions.overallLeadQualification = report.report_score_desc;
        lqcScoreDescriptions.overallLeadQualificationValueMessage = report.report_value_message;
      }else if(report.report_header === "Lead Calling Score" && report.report_display === "Y"){
        lqcScoreDescriptions.overallLeadCalling = report.report_score_desc;
        lqcScoreDescriptions.overallLeadCallingValueMessage = report.report_value_message;
      }
    })
    setReports(res.data.data);
    dispatcher(setLQCOverallDescriptions(lqcScoreDescriptions));
    return;
  } catch (error: any) {
    setReports([]);
    return;
  }
};

export const fetchLeadCallingSummaryReports = async (
  user_super_oid: number,
  report_date: string,
  report_type: string,
  setReports: any,
) => {
  try {
    let params: any = {
    user_super_oid,
    report_date,
    report_type,
    };
    const res = await axiosHandler.get(
      "reports/fetchLeadCallingSummaryReports",
      {
        params
      }
    );
    setReports(res.data.data);
    return;
  } catch (error: any) {
    setReports([]);
    return;
  }
};

export const fetchLeadPerformanceSummaryReport = async (
  user_super_oid: number,
  report_date: string,
  report_type: string,
  setReports: any,
) => {
  try {
    let params: any = {
    user_super_oid,
    report_date,
    report_type,
    };
    const res = await axiosHandler.get(
      "reports/fetchLeadPerformanceSummaryReport",
      {
        params
      }
    );
    setReports(res.data.data);
    return;
  } catch (error: any) {
    setReports([]);
    return;
  }
};

export const downloadDashboardAsPDF = (organizationName:string, dateRange:string) => {
  const dashboardElement = document.getElementById("leadQualityDashboard");
  // const elementsToHide = document.querySelectorAll("[data-hide-in-pdf]");

  // // Hide elements before capturing
  // elementsToHide.forEach((el:any) => (el.style.display = "none"));

  if (!dashboardElement) return;

  html2canvas(dashboardElement, { scale: 1.5 }).then((canvas) => {

    // Show elements again after capturing
    // elementsToHide.forEach((el:any) => (el.style.display = ""));

    const imgData = canvas.toDataURL("image/jpeg", 0.7);
    const pdf = new jsPDF("p", "mm", "a4");

    // Add custom text
    pdf.setFontSize(18);
    pdf.setFont("helvetica", "bold");
    pdf.setTextColor(43, 157, 165);
    pdf.text("Lead Quality Report", 10, 10);
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "normal");
    pdf.setTextColor(63, 63, 63);
    pdf.text(organizationName, 10, 15);
    pdf.text(`Period: ${dateRange}`, 10, 20);

    // Calculate image dimensions
    const imgWidth = 190; // Fit within A4 width
    let imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Ensure the image height doesn't exceed a single page
    if (imgHeight > 250) {
      imgHeight = 250; // Adjust if needed to fit A4
    }

    pdf.addImage(imgData, "JPEG", 10, 30, imgWidth, imgHeight);

    pdf.save(`${organizationName}  ${dateRange}`);
  });
};

export const fetchShowReportTab = async (
  user_super_oid: number,
  dispatcher: any
) => {
  try {
    let params: any = {
    user_super_oid,
    };
    const res = await axiosHandler.get(
      "reports/showReportTab",
      {
        params
      }
    );
    dispatcher(setShowReportTab(res.data.data.showReportTab));
  } catch (error: any) {
    dispatcher(setShowReportTab(false));
  }
};

export const fetchReportDropdown = async (
  user_super_oid: number,
  setDropdownOptions: any
) => {
  try {
    let params: any = {
    user_super_oid,
    };
    const res = await axiosHandler.get(
      "reports/fetchReportDropdown",
      {
        params
      }
    );
    setDropdownOptions(res.data.data);
  } catch (error: any) {
  }
};